export { default } from "bullitttime-embermodelsevent/models/penalty-timing-record";
